import styled from 'styled-components';

import { Button } from 'features/common/components/Button';
import { Text } from 'features/common/components/Text';
import { Table } from 'features/common/components/Table';

export const MainContainer = styled.div<{ isPunchup?: boolean }>`
	display: flex;
	justify-content: center;
	margin: ${({ isPunchup }) => (isPunchup ? '0' : '52px auto')};
	padding-left: ${({ theme, isPunchup }) => (isPunchup ? '0' : theme.widths.hiddenSidebar)};
	width: ${({ isPunchup }) => (isPunchup ? '100%' : '85%')};
	background-color: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.white : 'transparent')};
	min-height: ${({ isPunchup }) => (isPunchup ? '100vh' : 'auto')};
	overflow-x: hidden;
	overflow-y: ${({ isPunchup }) => (isPunchup ? 'auto' : 'visible')};

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		align-items: center;
		padding-left: 0px;
	}
`;

export const CenterContent = styled.div<{ isPunchup?: boolean }>`
	display: flex;
	flex-direction: column;
	gap: 16px;
	max-width: ${({ isPunchup }) => (isPunchup ? '100%' : '1300px')};
	width: 100%;
	padding: ${({ isPunchup }) => (isPunchup ? '20px' : '0')};
	box-sizing: border-box;
`;

export const ContentTitle = styled(Text)<{ isPunchup?: boolean }>`
	font-size: 32px;
	font-weight: 500;
	line-height: 150%;
	color: ${({ theme, isPunchup }) => (isPunchup ? theme.colors.grey8 : theme.colors.white)};

	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		text-align: center;
		text-transform: none;
		width: 80%;
	}
`;

export const ButtonContainer = styled.div`
	display: flex;
	gap: 16px;
	width: 100%;
`;

export const CustomButton = styled(Button)<{ isPunchup?: boolean; category?: string }>`
	font-size: 18px;
	font-weight: 600;
	height: 45px;
	margin: 0 0 24px 0;
	padding: 0px;
	width: 325px;
	background-color: ${({ theme, isPunchup, category }) =>
		category === 'outlined'
			? isPunchup
				? theme.colors.white
				: 'transparent'
			: isPunchup
			? theme.colors.punchupOrange || '#fe5e25'
			: theme.colors.green};
	border: ${({ theme, isPunchup, category }) =>
		category === 'outlined'
			? `2px solid ${isPunchup ? theme.colors.punchupOrange || '#fe5e25' : theme.colors.green}`
			: `2px solid ${isPunchup ? theme.colors.punchupOrange || '#fe5e25' : theme.colors.green}`};
	color: ${({ theme, isPunchup, category }) =>
		category === 'outlined'
			? isPunchup
				? theme.colors.punchupOrange || '#fe5e25'
				: theme.colors.green
			: theme.colors.white};

	&:hover {
		opacity: 0.9;
	}
`;

export const LoadMoreButton = styled(Table.LoadMore)``;

export const HiddenInput = styled.input`
	display: none;
`;
